import { Typography } from 'antd';
import styled from 'styled-components';
import { baseTextStyles } from './common.styled';

const { Paragraph } = Typography;

export const StyledParagraph = styled(Paragraph)`
  ${baseTextStyles}
`;
